import { Backdrop, Box, CircularProgress, Grid } from "@mui/material";
import { LoginViewModel } from "./LoginViewModel";
import { CustomImageView } from "../../component/CustomImageView";
import LoginForm from "./LoginForm";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import { COLOR_MAIN, COLOR_WHITE } from "../../../data/colors/Colors";
import { provideLoginUseCase } from "../../di/UseCasesModule";
import { APP_BG_IMAGE } from "../../../data/constant/Constants";

export default function LoginView() {
  const { login, isLoading } = LoginViewModel(provideLoginUseCase());
  const { width } = useWindowDimensions();

  return (
    <Box>
      <Grid container>
        <Grid size={{ xs: 0, md: 6, xl: 8 }}>
          <Box
            sx={{
              height: "100%",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
              background: COLOR_MAIN,
            }}
          >
            <CustomImageView
              width={width > 900 ? "100%" : "0%"}
              height={width > 900 ? "100%" : "0%"}
              src={APP_BG_IMAGE}
              props={{ borderTopRightRadius: 80, borderBottomRightRadius: 80 }}
            />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6, xl: 4 }} sx={{ background: COLOR_MAIN }}>
          <LoginForm onSubmit={login} />
        </Grid>
      </Grid>
      <Backdrop
        sx={{ color: COLOR_WHITE, zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}
